import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/ChooseEnding.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/SetHtmlLang.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/tufte.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/toc.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/tufte-charts.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/translations/ja/app/ArticleContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/translations/ja/Provider.tsx");
